import { useQuery } from "@tanstack/react-query";
import { getBookMark } from "../api/user";
import { BookMarkParams } from "../types/types";

const useGetBookMark = ({ admin_idx }: BookMarkParams) => {
  const { data } = useQuery({
    queryKey: ["BookMark", `admin_idx-${admin_idx}`],
    queryFn: () => getBookMark({ admin_idx }),

    staleTime: 1000 * 3 * 60,
  });
  return { data };
};

export default useGetBookMark;
